import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName} from '../../Toolkit/Icons';
import {GotoIconName} from '../SafeDigConstants';
import TaskEditDialog from '../Dialogs/TaskEditDialog';
import {DataTableSortMeta} from 'primereact/datatable';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import {Notice} from '../../Api/NoticeTypes';
import EnumContext from '../../Context/enum-context';

type SubNoticeRow = {
    data: Notice;
}

type Props = {
    rowData: Notice[];
    navigateTo: (id: number, newJob: boolean) => void;
}

/** */
type State = {
    filters: MTableFilters;
    selectedRow?: SubNoticeRow;
}

class SubNoticeControl extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>;

    private readonly m_editRef: RefObject<TaskEditDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_editRef = createRef<TaskEditDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.edit_Click = this.edit_Click.bind(this);
        this.new_Click = this.new_Click.bind(this);
        this.isGotoDisabled = this.isGotoDisabled.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private isGotoDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private table_onSelectionChange(selection: SubNoticeRow | SubNoticeRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as SubNoticeRow | undefined);

    }

    private edit_Click(): void {
        this.props.navigateTo(this.state.selectedRow!.data!.header!.id, false);
    }

    private new_Click(): void {
        this.props.navigateTo(-1, true);
    }

    private startDateTemplate = (rowData: SubNoticeRow): string => {
        if(rowData.data.detail!.startDate != null) {
            try {
                return rowData.data.detail!.startDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private endDateTemplate = (rowData: SubNoticeRow): string => {
        if(rowData.data.detail!.endDate != null) {
            try {
                return rowData.data.detail!.endDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private phaseTypeTemplate = (rowData:SubNoticeRow) : string => {
        const index = this.context.enums?.phaseTypes.findIndex(value => value.id === rowData.data.detail!.phaseType);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.phaseTypes[index!].name ?? '';
    }

    private permitStatusTemplate = (rowData:SubNoticeRow) : string => {
        const index = this.context.enums?.permitStates.findIndex(value => value.id === rowData.data.detail!.permitStatus);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.permitStates[index!].name ?? '';
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'data.odinId', order: 1}
        ];
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                <MToolbar>
                    <MButton label="Add"
                             icon={MNewIconName}
                             color={"success"}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Go To"
                             icon={GotoIconName}
                             disabled={this.isGotoDisabled}
                             onClick={this.edit_Click}/>
                </MToolbar>
                <MTable
                    rowKey="data.id"
                    rowData={this.props.rowData.map(s => {return {data: s} as SubNoticeRow})}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()}>

                    <Column field="data.header.odinId"
                            header="Odin ID"
                            filter={false}
                            sortable={true}
                            style={{width: '20%'}}/>
                    <Column field="data.header.notice.startDate"
                            header="Start Date"
                            dataType="date"
                            filter={false}
                            sortable={true}
                            body={this.startDateTemplate}
                            style={{width: '20%'}}/>
                    <Column field="data.header.notice.endDate"
                            header="End Date"
                            dataType="date"
                            filter={false}
                            sortable={true}
                            body={this.endDateTemplate}
                            style={{width: '20%'}}/>
                    <Column field="data.header.phaseType"
                            header="Phase Type"
                            filter={false}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.phaseTypeTemplate}
                            style={{width: '20%'}}/>
                    <Column field="data.header.permitStatus"
                            header="Permit Status"
                            filter={false}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.permitStatusTemplate}
                            style={{width: '20%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default SubNoticeControl;